import {
  CurriculaVMModel, SubjectModel,
} from '../../../Elearning-Models';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ExtraOptions } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { IServiceFactory } from '../../../Services/service-factory';

import { CurriculumService } from 'src/app/Services/curriculum.service';
import { environment } from 'src/environments/environment';

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'enabled',
  anchorScrolling: 'enabled'
}; 
@Component({
  selector: 'app-curriculum-list',
  templateUrl: './curriculum-list.component.html',
  styleUrls: ['./curriculum-list.component.scss'],
})


export class CurriculumListComponent implements OnInit, OnDestroy {

  dataService: CurriculumService;
  public curriculumData: CurriculaVMModel;
  public curriculumDataReceived: boolean = false;
  //  chosenGrade: SubjectModel;
  imagePath = environment.imagePath + 'assets/images/curriculumImages/';


  constructor(
    public dialog: MatDialog,
    private serviceFactory: IServiceFactory,
    public router: Router,
    public route: ActivatedRoute,
  ) {
    this.dataService = this.serviceFactory.getCurriculumService();
  }

  ngOnInit(): void {
    this.getCurriculumData();
  }

  /**
   * This method is used to get list of curriculum data.
   */
  getCurriculumData = (): void => {
    this.curriculumDataReceived = false;
    this.dataService.GetCurriculumData().subscribe((response: CurriculaVMModel) => {
      this.curriculumData = response;
      if (!this.curriculumData.IsTeacher){
        this.router.navigate([environment.rootPath + 'Course']);
      }
      this.curriculumDataReceived = true;
    });
  }

  ngOnDestroy(): void {
  }

  /////////////

  // chooseGrade(grade: SubjectModel){
  //   this.chosenGrade = grade;
  // }

  /**
   * This method is used to redirect to curriculum register page.
   */
  redirectToCurriculumRegister = (data): void => {
    this.router.navigate([environment.rootPath + 'CurriculumRegister/' + data.CurriculumID])
  }
}
